import styled from 'styled-components';
import * as PropTypes from 'prop-types';
var propTypes = {
  duration: PropTypes.string,
  timingFunction: PropTypes.string,
  delay: PropTypes.string,
  iterationCount: PropTypes.string,
  direction: PropTypes.string,
  fillMode: PropTypes.string,
  playState: PropTypes.string,
  display: PropTypes.string
};
var defaultProps = {
  duration: '1s',
  timingFunction: 'ease',
  delay: '0s',
  iterationCount: '1',
  direction: 'normal',
  fillMode: 'both',
  playState: 'running',
  display: 'block'
};
var AnimationBase = styled.div.withConfig({
  displayName: "AnimationBase",
  componentId: "sc-180ucwv-0"
})(["animation-duration:", ";animation-timing-function:", ";animation-delay:", ";animation-iteration-count:", ";animation-direction:", ";animation-fill-mode:", ";animation-play-state:", ";display:", ";"], function (props) {
  return props.duration;
}, function (props) {
  return props.timingFunction;
}, function (props) {
  return props.delay;
}, function (props) {
  return props.iterationCount;
}, function (props) {
  return props.direction;
}, function (props) {
  return props.fillMode;
}, function (props) {
  return props.playState;
}, function (props) {
  return props.display;
});
AnimationBase.propTypes = propTypes;
AnimationBase.defaultProps = defaultProps;
export { AnimationBase };